import React from "react"
import SEO from "components/seo"
import View from "framework/alto/ui/view";
import css from "pages/intro.module.css";
import introExample from "images/intro-example.png";
import "../common_styles/code_blocks.css";
import 'common_styles/common.css';

const IntroPage = () => (
    <View className={css.base}>
        <SEO title="Intro"
             keywords={[`alto.js`, `alto-react`, `alto-ui`, 'react.js', 'react', 'javascript', 'application framework']}/>

        <View className={css.content}>
            <View className={css.titlearea}>
                <h2>Intro</h2>
            </View>

            <View className={css.contentarea}>

                <View className={css.textCell}>
                    <View className={css.p}>
                        Alto derives from a rich history of industry leading frameworks and design patterns. Leveraging
                        modern languages, tools, and api's, Alto aims to bring a coherent application architecture
                        across multiple development communities.  Specifically, Alto.js is Application Architecture for
                        React.js
                        <br/> <br/>
                        Today, popular tooling for web applications excel at solving view concerns but fail to provide
                        what is needed to build complete applications. In the absence of a complete solution, we find
                        ourselves reaching for multiple npm packages to fill in the blanks. This behavior encourages
                        engineers and teams alike to build each application with a unique stack, design pattern, and/or
                        components.
                        <br/> <br/>
                        It is here at this moment, where a careless gesture of unique package installs per each team,
                        per each engineer, and per each product, when our tools let us down. This disconnected tooling
                        in professional team environments is a bottle neck. To build web applications to the highest
                        degree of consistency and productivity is to embrace common design patterns and structure.
                        <br/> <br/>
                        Alto.js aims to be a complete solution for building world class web applications on all devices
                        with modern browsers.
                        <br/> <br/>
                        Getting your first alto.js application up and running is easy. With the latest version of
                        node.js and npx installed. Simply run the following command to generate your alto.js application.
                    </View>
                </View>

                <div><br/></div>

                <div className="cell code-cell">
                    <div className="ace-github">
                        <div className="ace_static_highlight">
                            <div className="ace_line"><span className="ace_identifier">$ npx</span> <span
                                className="ace_identifier">alto</span>.<span className="ace_identifier">js</span> <span
                                className="ace_identifier">helloworld</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div><br/></div>

                <View className={css.textCell}>
                    <View className={css.p}>
                        Once created, change directory into your application and start your projects local server.
                    </View>
                </View>

                <div><br/></div>

                <div className="cell code-cell">
                    <div className="ace-github">
                        <div className="ace_static_highlight">
                            <div className="ace_line">$ <span className="ace_support ace_function ace_builtin">cd </span>
                                <span className="ace_identifier">helloworld</span>
                            </div>
                            <div className="ace_line">$ <span className="ace_identifier">npm</span> <span
                                className="ace_identifier">run</span> <span className="ace_identifier">start</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div><br/></div>

                <View className={css.textCell}>
                    <View className={css.p}>
                        Your application is now viewable in your browser at&nbsp;
                        <a className={css.link} href="http://localhost:3000/">http://localhost:3000/</a>&nbsp;and you should
                        see the following.
                    </View>
                </View>

                <div><br/></div>

                <View className={css.textCell}>
                    <img className={css.image} src={introExample} alt="helloworld_example.png" width="742" height="566"/>
                </View>

            </View>
        </View>

    </View>
)

export default IntroPage
